import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSearch?: () => void;
  className?: string;
  showLengthFilter?: boolean;
  selectedLength?: number | null;
  onLengthChange?: (length: number | null) => void;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = "Skriv din korsordsfråga...",
  onSearch,
  className,
  showLengthFilter = false,
  selectedLength,
  onLengthChange,
}: SearchInputProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && onSearch) {
      onSearch();
    }
  };

  const lengthOptions = Array.from({ length: 29 }, (_, i) => i + 2); // 2-30

  return (
    <div className={cn("relative w-full flex gap-2", className)}>
      <div className="relative flex-1">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className={cn(
            "w-full px-5 py-4 pr-14 rounded-xl",
            "bg-card border-2 border-border",
            "text-foreground placeholder:text-muted-foreground",
            "focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/10",
            "transition-all duration-200",
            "text-lg font-body shadow-soft"
          )}
        />
        <button
          onClick={onSearch}
          className={cn(
            "absolute right-2 top-1/2 -translate-y-1/2",
            "p-3 rounded-lg bg-primary text-primary-foreground",
            "hover:bg-primary/90 active:scale-95",
            "transition-all duration-200 shadow-soft"
          )}
        >
          <Search className="w-5 h-5" />
        </button>
      </div>
      {showLengthFilter && (
        <Select
          value={selectedLength?.toString() || "all"}
          onValueChange={(val) => onLengthChange?.(val === "all" ? null : parseInt(val))}
        >
          <SelectTrigger className="w-24 h-[58px] border-2 border-border rounded-xl bg-card text-foreground">
            <SelectValue placeholder="Längd" />
          </SelectTrigger>
          <SelectContent className="bg-card border-border z-50">
            <SelectItem value="all">Alla</SelectItem>
            {lengthOptions.map((len) => (
              <SelectItem key={len} value={len.toString()}>
                {len} tecken
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
